export class Windower {
    constructor(size, array, offset = 0) {
        this.size = size;
        this.array = array;
        this.offset = offset;
    }
    current() {
        const endIndex = this.size + this.offset;
        if (endIndex > this.array.length) {
            return null;
        }
        return this.array.slice(this.offset, this.offset + this.size);
    }
    advance(amount = 1) {
        this.offset = this.offset + amount;
        return this;
    }
}
